<template>
  <div>
    <GenericPage>
      <template slot="breadcrumb-items">
        <li class="active bold">Seguridad y Antifraude</li>
      </template>
      <template slot="title">
        Sugerencias de seguridad.
      </template>
      <template slot="body">
        <h2 class="title">En la Red queremos que estés <span class="primary">segur@</span>.</h2>
        <p class="mb--90">
          La seguridad juega un papel muy importante en el cuidado de la información y de todas tus operaciones, por lo
          que queremos compartirte una serie de medidas y recomendaciones que harán que tu experiencia en la Red sea aún
          más segura.
          <strong>Consúltalas a continuación.</strong>
        </p>
        <div class="row">
          <div class="col-lg-8">
            <SecAdvContent :value="contentPage" />
          </div>
          <div class="col-lg-4">
            <div class="axil-sidebar">
              <div class="widget widget-categories">
                <h4 class="widget-title">Categoría</h4>
                <ul class="category-list list-unstyled">
                  <li><a @click.stop="contentPage = 1">Nuestra plataforma</a></li>
                  <li><a @click.stop="contentPage = 2">Tu contraseña</a></li>
                  <li><a @click.stop="contentPage = 3">Tu correo electrónico</a></li>
                  <li><a @click.stop="contentPage = 5">Evita una estafa</a></li>
                  <li><a @click.stop="contentPage = 4">¡Cuídate!</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </template>
    </GenericPage>
  </div>
</template>

<script>
import GenericPage from "./new-portal-views/GenericPage.vue";
import SecAdvContent from "../components/security-advices/SecAdvContent.vue";

export default {
  name: "SecurityAdvices",
  components: {
    GenericPage,
    SecAdvContent
  },
  data() {
    return {
      contentPage: 1
    }
  }
}
</script>

<style scoped></style>